import React from 'react';
import { Text, Icon, Box, Flex } from '@spothero/ui';
import { Calendar as IconCalendar } from '@spothero/icons';
const AccessHours = ({ hoursOfOperation, rateAccessHoursFormatted, facilityAccessHoursFormatted, displayHoursComment, }) => {
    const renderPeriods = hours => {
        return hours.map((period, i) => {
            return (<Text color="text.secondary.light" fontSize="sm" key={i}>
                    {period.days}, {period.value}
                </Text>);
        });
    };
    const renderOffRate = () => {
        if (rateAccessHoursFormatted) {
            return (<Box display="inline">
                    {rateAccessHoursFormatted.length === 1 &&
                    rateAccessHoursFormatted[0].type === '247' ? (<Text color="text.secondary.light" fontSize="sm">
                            This facility is open 24/7
                        </Text>) : (renderPeriods(rateAccessHoursFormatted))}
                </Box>);
        }
        else {
            if (hoursOfOperation.text.length > 0) {
                return (<Text className="AccessHoursDetailsCentered" color="text.secondary.light" fontSize="sm">
                        {hoursOfOperation.text[0]}
                    </Text>);
            }
            else {
                return null;
            }
        }
    };
    const renderOffFacility = () => {
        return (<Box display="inline">
                {facilityAccessHoursFormatted &&
                facilityAccessHoursFormatted.length === 1 &&
                facilityAccessHoursFormatted[0].type === '247' ? (<Text color="text.secondary.light" fontSize="sm">
                        This facility is open 24/7
                    </Text>) : (renderPeriods(facilityAccessHoursFormatted || []))}
            </Box>);
    };
    const renderDisplayHoursComment = () => {
        if (!displayHoursComment) {
            return null;
        }
        return (<Text className="AccessHoursDetailsCentered" color="text.secondary.light" fontSize="sm">
                {displayHoursComment}
            </Text>);
    };
    return (<Flex data-testid="Monthly-AccessHours" mt={2}>
            <Icon as={IconCalendar} color="text.secondary.light" mr={1} mt={0.5}/>
            {rateAccessHoursFormatted ||
            displayHoursComment ||
            hoursOfOperation?.text?.length ? (<span>
                    {renderOffRate()}
                    {renderDisplayHoursComment()}
                </span>) : (renderOffFacility())}
        </Flex>);
};
export default AccessHours;
